import { message } from 'antd';
import { useTranslations } from 'next-intl';

export const errorHandler = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const t = useTranslations();

  return (error: any) => {
    if (error.message === 'Network Error') {
      message.error(t('internet_yoq_tarmoqqa_ulanishingizni_tekshiring'));
    } else if (error.response?.status === 400) {
      message.error(error.response.data?.message || t('xatolik_yuz_berdi'));
    } else {
      message.error(t('nomalum_xatolik_yuz_berdi'));
    }
  };
};
